import { callApi } from "./api.service";
import { UserData } from "../types/types";

// Define the function to fetch a user profile (Token required)
export const fetchUserProfile = async (
  getToken: () => Promise<string | null> // Get token function passed here
) => {
  const endpoint = `/api/users`;
  return await callApi(endpoint, "GET", true, getToken);
};

// Define the function to add user profile data (Token required)
export const AddUserProfile = async (
  Data: UserData,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/users/create`;
  return await callApi(endpoint, "POST", true, getToken, Data);
};

// Define the function to update user profile data (Token required)
export const UpdateUserProfile = async (
  Data: UserData,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/users/update`;
  return await callApi(endpoint, "PUT", true, getToken, Data);
};

// Define the function to get stripe client secret (Token required)
export const GetStripeClientSecret = async (
  Data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/payment/create-payment-intent`;
  return await callApi(endpoint, "POST", true, getToken, Data);
};

export const AddUserProfileImage = async (
  Data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/user/profile-picture/upload`;
  const headers: Record<string, string> = {
    "Content-Type": "multipart/form-data",
  };
  return await callApi(endpoint, "POST", true, getToken, Data, headers);
};

export const UnlinkSocialConnection = async (
  Data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/connect/unlinkConnection`;
  return await callApi(endpoint, "POST", true, getToken, Data);
};

export const ResetPassword = async (getToken: () => Promise<string | null>) => {
  const endpoint = `/api/users/change-password`;
  return await callApi(endpoint, "POST", true, getToken);
};
